export const MYPOSTLIMIT = 5;
export const FEEDPOSTLIMIT = 10;
export const ALLPOSTLIMIT = 100;
